// src/pages/ShopLater.jsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion } from "framer-motion";

const ShopLater = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Remove the unlock status and redirect to Unlock Page
    localStorage.removeItem("unlocked");

    // Optional: Add a slight delay for smoother UX
    const timer = setTimeout(() => {
      navigate("/");
    }, 1500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col bg-black text-rose-300">
      {/* Header Section */}
      <Header />

      {/* Main Content */}
      <div className="flex flex-grow pt-28 pb-12 px-4 md:px-8 justify-center items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="glass w-full max-w-lg text-center px-4 sm:px-8 py-8"
        >
          {/* Title */}
          <motion.h2
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="text-3xl sm:text-2xl md:text-5xl font-extrabold mb-6 tracking-wide leading-tight"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Closing the <span className="text-white">Shop</span>...
          </motion.h2>

          {/* Description */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="text-sm sm:text-base md:text-lg mb-8 leading-relaxed"
          >
            See you soon! Redirecting to Unlock Page...
          </motion.p>
        </motion.div>
      </div>

      {/* Footer Section */}
      <Footer />
    </div>
  );
};

export default ShopLater;
